const formatCurrency = (amountValue, locale = 'en-US') => {
  if (!amountValue) {
    return null;
  }

  const { currency, amount } = amountValue;

  // First format the number according to locale
  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  // Use the currency's format string to place the symbol correctly
  return (
    currency.format?.format.replace('__price__', formattedNumber) ||
    `${formattedNumber} ${currency.character}`
  );
};

export { formatCurrency };
